export const BOOKING_MAX_DAYS_AHEAD = 84; 
export const RESCHEDULE_LIMIT_PER_MONTH = 1;
// A session may move no later than this many days after the date it was first booked for —
// mirrors backend RESCHEDULE_MAX_DAYS_FROM_ORIGINAL.
export const RESCHEDULE_MAX_DAYS_FROM_ORIGINAL = 84;

// status field for booking table
export const booking_status = {
  CANCELLED: "cancelled", // system cancel
  CONFIRMED: "confirmed",
  PENDING: "pending",
  TERMINATED: "terminated", // user cancel
  CANCELLING: "cancelling",
  COMPLETED: "completed",
  FAILED: "failed",
  EXPIRED: "expired", // checkout timeout — nobody acted
};

// status field for both_booking_session table (always lowercase)
export const both_booking_session_status = {
  PENDING: "pending",
  CONFIRMED: "confirmed",
  COMPLETED: "completed",
  TERMINATED: "terminated", // user cancel
  CANCELLED: "cancelled", // system cancel
  FAILED: "failed",
  EXPIRED: "expired",
  PAUSED: "paused", // admin-paused subscription session
};


export const general_frequency = {
  ONETIME: "one_time", // general + aircon
  WEEKLY: "weekly", // general
  QUARTERLY: "quarterly", // aircon
  FORTNIGHTLY: "fortnightly", // general
};

export const SERVICE_ID = {
  GENERAL_CLEANING: 1,
  AIRCON_SERVICING: 2,
};

export const PROMOTION_CREDITS = {
  GENERAL_CLEANING_ONE_TIME: 1,
  AIRCON_SERVICING_ONE_TIME: 2,
  ALL_ONE_TIME_SERVICES: 3,
  AIRCON_ADDON_QUARTERLY: 4,
};
